import { connect } from 'react-redux';
import { compose } from 'redux';
import { withNavigation } from 'react-navigation';
import BusTransactionListItem from '../components/BusTransactionListItem';
import { BUS_TRANSACTION_LIST_SCHEMA_KEY } from '../schemas/busTransactionListInventorySchema';
import isInSameDay from 'common/utils/date/isInSameDay';

const getTransactionListItemById = (state, id) =>
  state.entities[BUS_TRANSACTION_LIST_SCHEMA_KEY][id];

const mapStateToProps = (state, { id, index }) => {
  const inventory = getTransactionListItemById(state, id);
  let shouldShowDateBeforeCard = false;
  if (index === 0) shouldShowDateBeforeCard = true;
  else {
    const previousInventoryId =
      state.bus.transactionList.inventories[index - 1];
    shouldShowDateBeforeCard = !isInSameDay(
      inventory.specificDate,
      getTransactionListItemById(state, previousInventoryId).specificDate
    );
  }
  return { ...inventory, shouldShowDateBeforeCard };
};

export default compose(
  connect(mapStateToProps),
  withNavigation
)(BusTransactionListItem);
